import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));
const OOSRateByDate = Loadable(lazy(() => import('pages/oosbydate/OOSRateByDate')));
const Accuracy = Loadable(lazy(() => import('pages/accuracy/Accuracy')));
const Inventory = Loadable(lazy(() => import('pages/inventory/Inventory')));
const OOSRateBySubdept = Loadable(lazy(() => import('pages/oosbysubdept/OOSRateBySubdept')));
// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/SamplePage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'accuracy',
      element: <Accuracy />
    },
    {
      path: 'inventoryflow',
      element: <Inventory />
    },
    {
      path: 'oos',
      children: [
        {
          path: 'date',
          element: <OOSRateByDate />
        },
        {
          path: 'subdept',
          element: <OOSRateBySubdept />
        }
      ]
    }
  ]
};

export default MainRoutes;
